import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "@ignitesales/neuro-application/src/neuro-ui/lib/index";
import {PrintButton, ShareViaEmailForm, useNeuroMessages, triggerIgniteAction, useDispatch, ShareViaSmsForm, notifySuccess} from "@ignitesales/neuro-application";
import {useDialogueGuideSettings} from "../hooks/useDialogueGuideSettings.mjs";
import { ActionService } from '../services/ActionService.mjs';
import { useEffect } from 'react';
import GuideApiService from '../services/GuideApiService.mjs';

const ShareActionTypes = {
    showAll: 'showAll', email: 'shareViaEmail', textMessage: 'shareViaSms', print: 'print'
};

const ShareActions = ({isActive, onClose}) => {
    const { useTextResultsAction, useEmailResultsAction } = useDialogueGuideSettings();
    const {getMessage} = useNeuroMessages();
    const dispatch = useDispatch();
    const [actionType, setActionType] = useState(ShareActionTypes.showAll);
    const [emailActions, setEmailActions] = useState([]);
    const [smsActions, setSMSActions] = useState([]);
    const [hasActionTriggerEmail, setHasActionTriggerEmail] = useState(false);
    const [hasActionTriggerSMS, setHasActionTriggerSMS] = useState(false);
    const componentClass = 'shareActions';

    useEffect(()=> {
        const fetchActions = async () => {
            const eActions = await ActionService.getActionsByTriggerType('shareEmail');
            const sActions = await ActionService.getActionsByTriggerType('shareSMS');
            if(eActions && Array.isArray(eActions) && eActions.length){
                setHasActionTriggerEmail(true)
            } else setHasActionTriggerEmail(false);
            if(sActions && Array.isArray(sActions) && sActions.length){
                setHasActionTriggerSMS(true)
            } else setHasActionTriggerSMS(false);
            setEmailActions(eActions);
            setSMSActions(sActions);
        }

        fetchActions();
    }, [])

    const actionClicked = actionName => {
        dispatch(triggerIgniteAction({actionName: `${actionName}Clicked`, value: 'started'}));
        setActionType(actionName);
    };

    const onCloseModal = () => {
        onClose();
        setTimeout(() => setActionType(ShareActionTypes.showAll), 500);
    }

    const triggerAction = async (action, triggerId) => {
        return await ActionService.triggerAction(action, triggerId, await ActionService.extractActionParams(action));
    }

    const triggerAllActions = (actions, type = "shareEmail") => {
        for(let action of actions){
            const triggers = ActionService.extractAllTriggersByTriggerType(action, type);
            for(let trigger of triggers){
                triggerAction(action, trigger._id);
            }
        }
    }

    const actionCompleted = (emailOrNumber) => {
        if(actionType == ShareActionTypes.email && hasActionTriggerEmail){
            if(!GuideApiService.lead) GuideApiService.lead = {};
            GuideApiService.lead.email = emailOrNumber;
            triggerAllActions(emailActions, 'shareEmail');
        }
        if(actionType == ShareActionTypes.textMessage && hasActionTriggerSMS){
            if(!GuideApiService.lead) GuideApiService.lead = {};
            GuideApiService.lead.phone = emailOrNumber;
            triggerAllActions(smsActions, 'shareSMS');
        }
        notifySuccess(`${actionType}.sent`);
        onCloseModal();
    };

    const allOptionsRender = <div className={`${componentClass}__buttons`}>
        { useEmailResultsAction !== false && <button className="btn btn-outline-secondary" onClick={() => actionClicked(ShareActionTypes.email)}>Email</button> }
        { useTextResultsAction !== false && <button className="btn btn-outline-secondary" onClick={() => actionClicked(ShareActionTypes.textMessage)}>Text Message</button> }
        <PrintButton className="btn btn-outline-secondary" onClick={onClose} shouldOpenDetailsPage={false}>Print</PrintButton>
    </div>;

    return <Modal nodeId='root' className={componentClass} onClose={onCloseModal} show={isActive} title={getMessage('shareActions.title')}>
        {actionType === ShareActionTypes.showAll && allOptionsRender}
        {actionType === ShareActionTypes.email && <ShareViaEmailForm skipSending={hasActionTriggerEmail} onSubmit={actionCompleted}/>}
        {actionType === ShareActionTypes.textMessage && <ShareViaSmsForm skipSending={hasActionTriggerSMS} onSubmit={actionCompleted}/>}
    </Modal>;
};

ShareActions.propTypes = {
    isActive: PropTypes.bool.isRequired, onClose: PropTypes.func.isRequired
};

export default ShareActions;
